<template>
  <app-stepper-section :label="$t('message.generics.message.masterUser')">

    <v-text-field :label="$t('message.generics.message.userName')"
                  v-model="name"
                  :disabled="edit"
                  v-validate="'required'"
                  name="Nome do Usuário"
                  :error-messages="errors.collect($t('message.generics.message.userName'))"></v-text-field>

    <v-text-field :label="$t('message.generics.message.email')"
                  v-model="email"
                  :disabled="edit"
                  v-validate="'required'"
                  name="E-mail"
                  :error-messages="errors.collect($t('message.generics.message.email'))"></v-text-field>

    <v-text-field v-if="!edit"
                  :label="$t('message.generics.message.phoneNumber')"
                  v-model="phone"
                  :disabled="edit"
                  v-validate="'required'"
                  name="Telefone"
                  :error-messages="errors.collect($t('message.generics.message.phoneNumber'))"></v-text-field>

    <app-user-modal-footer v-if="step"
                           @click="advanceStep">{{$t('message.generics.message.advance')}}</app-user-modal-footer>

  </app-stepper-section>
</template>

<script>
    import AppStepperSection from '../../../StepperSection'
    import AppUserModalFooter from "@components/user-modal/components/UserModalFooter";
    import userModalSection from '../mixins/user-modal-section'


    export default {
        components: {
            AppStepperSection,
            AppUserModalFooter
        },

        data() {
            return {
            }
        },

        mixins: [userModalSection],

        props: {
            value: {
                type: Object
            },
            step: {
                type: Boolean,
                default: true
            },
            edit: {
                type: Boolean,
                default: false
            },
        },

        methods: {
            async advanceStep() {
                const isValid = await this.$validator.validateAll()

                if(isValid) {
                    this.$emit('advance')
                }
            }
        },

        computed: {

            name: {
                get() {
                    return this.value.name
                },
                set(name) {
                    this.$emit('input', {...this.value, name})
                },
            },

            email: {
                get() {
                    return this.value.email
                },
                set(email) {
                    this.$emit('input', {...this.value, email})
                },
            },

            phone: {
                get() {
                    return this.value.phone
                },
                set(phone) {
                    this.$emit('input', {...this.value, phone})
                },
            },

        },
    }
</script>

<style scoped>
</style>
